function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "iconCategorySettings");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Frame_-_24px"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}));

var SvgIconCogs = function SvgIconCogs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, /*#__PURE__*/React.createElement("g", {
    id: "Academy-New-concept",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-130.000000, -861.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dooer-Academy-V2-Copy-2",
    transform: "translate(100.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(0.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-items",
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Not-expanded",
    transform: "translate(30.000000, 260.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-item",
    transform: "translate(0.000000, 400.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cog-double"
  }, _ref5, /*#__PURE__*/React.createElement("g", {
    id: "Line_Icons",
    transform: "translate(1.666667, 1.666667)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999"
    },
    d: "M14.7716667,10 L13.0416667,10 C12.3533333,11.94 10.505,13.3333333 8.33333333,13.3333333 C5.57583333,13.3333333 3.33333333,11.0916667 3.33333333,8.33333333 C3.33333333,6.16166667 4.72833333,4.31416667 6.66666667,3.625 L6.66666667,1.895 C5.9175,2.09 5.2125,2.39583333 4.58916667,2.82083333 L3.32416667,1.55666667 L1.55666667,3.32416667 L2.82166667,4.58916667 C2.39583333,5.21333333 2.08,5.915 1.88666667,6.66666667 L0,6.66666667 L0,10 L1.88666667,10 C2.08,10.7525 2.39583333,11.4533333 2.82166667,12.0775 L1.55666667,13.3425 L3.32416667,15.1108333 L4.58916667,13.8458333 C5.21333333,14.2708333 5.91583333,14.5858333 6.66666667,14.7808333 L6.66666667,16.6666667 L10,16.6666667 L10,14.7808333 C10.7508333,14.5866667 11.4533333,14.2708333 12.0775,13.8458333 L13.3425,15.1108333 L15.11,13.3425 L13.845,12.0775 C14.27,11.4541667 14.5766667,10.7491667 14.7716667,10 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999"
    },
    d: "M16.6666667,4.92416667 L16.6666667,3.40833333 L15.4233333,3.40833333 C15.3558333,3.14833333 15.2541667,2.905 15.125,2.67833333 L15.9091667,1.89333333 L14.7733333,0.7575 L13.9875,1.54166667 C13.7608333,1.41166667 13.5175,1.31083333 13.2566667,1.24333333 L13.2566667,0 L11.7425,0 L11.7425,1.24333333 C11.4825,1.31083333 11.2391667,1.41166667 11.0125,1.54166667 L10.2275,0.7575 L9.09083333,1.89333333 L9.87583333,2.67833333 C9.74666667,2.905 9.645,3.14833333 9.57666667,3.40833333 L8.33333333,3.40833333 L8.33333333,4.92333333 L9.57583333,4.92333333 C9.64416667,5.18333333 9.74583333,5.42666667 9.875,5.65416667 L9.09,6.43916667 L10.2266667,7.575 L11.0116667,6.79166667 C11.2383333,6.92083333 11.4816667,7.0225 11.7416667,7.09 L11.7416667,8.33333333 L13.2558333,8.33333333 L13.2558333,7.09083333 C13.5166667,7.0225 13.7591667,6.92166667 13.9866667,6.7925 L14.7716667,7.57583333 L15.9075,6.44 L15.1233333,5.655 C15.2525,5.4275 15.3541667,5.18416667 15.4216667,4.92416667 L16.6666667,4.92416667 Z M12.5,5.83333333 C11.5791667,5.83333333 10.8333333,5.08666667 10.8333333,4.16666667 C10.8333333,3.24666667 11.5791667,2.5 12.5,2.5 C13.4208333,2.5 14.1666667,3.24666667 14.1666667,4.16666667 C14.1666667,5.08666667 13.4208333,5.83333333 12.5,5.83333333 Z",
    id: "Shape"
  })))))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCogs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-cogs.4d54ce2d.svg";
export { ForwardRef as ReactComponent };